(function () {
  var params = new URLSearchParams(window.location.search || '');
  var productPage = window.location.pathname.indexOf('/products/') !== -1;
  var storageKey = 'arthur:pdp-diagnostics:last-visit';
  var eventQueueKey = 'arthur:pdp-diagnostics:event-queue';
  var sessionKey = 'arthur:pdp-diagnostics:enabled';
  var queue = [];
  var sentCount = 0;
  var maxEvents = 60;
  var visitId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  var startedAt = Date.now();
  var lastStage = 'boot';
  var heartbeatTimer;
  var interactionState = {
    swipeCount: 0,
    mediaVisibleCount: 0,
    lastDirection: null,
    lastDeltaX: null,
    lastDeltaY: null,
    lastMediaId: null,
    lastSlideIndex: null,
    lastImageSrc: null,
    lastImageWidth: null,
    lastInteractionAt: null
  };

  if (params.get('aa_diag') === '1') {
    try {
      window.sessionStorage.setItem(sessionKey, '1');
    } catch (error) {}
  } else if (params.get('aa_diag') === '0') {
    try {
      window.sessionStorage.removeItem(sessionKey);
      window.localStorage.removeItem(storageKey);
    } catch (error) {}
    return;
  }

  var enabled = false;
  try {
    enabled = window.sessionStorage.getItem(sessionKey) === '1';
  } catch (error) {}

  if (!productPage || !enabled) return;

  function safeStorageRead() {
    try {
      var value = window.localStorage.getItem(storageKey);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function safeStorageWrite(payload) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(payload));
    } catch (error) {}
  }

  function compactForStorage(payload) {
    var extra = payload.extra || {};
    var stats = extra.stats || extra.currentStats || null;
    var slideState = extra.slideState || null;
    var previous = extra.previous || null;

    return {
      message: payload.message,
      level: payload.level,
      tags: payload.tags,
      at: Date.now(),
      extra: {
        visitId: extra.visitId,
        stage: extra.stage,
        href: extra.href ? String(extra.href).slice(0, 300) : undefined,
        trigger: extra.trigger,
        durationMs: extra.durationMs,
        interactionState: extra.interactionState,
        slideState: slideState ? {
          rootId: slideState.rootId,
          mediaId: slideState.mediaId,
          slideIndex: slideState.slideIndex,
          imageSrc: slideState.imageSrc ? String(slideState.imageSrc).slice(0, 300) : null,
          imageWidth: slideState.imageWidth,
          imageNaturalWidth: slideState.imageNaturalWidth,
          imageNaturalHeight: slideState.imageNaturalHeight,
          imageComplete: slideState.imageComplete,
          imageLoading: slideState.imageLoading,
          imageFetchPriority: slideState.imageFetchPriority,
          slideCount: slideState.slideCount
        } : undefined,
        stats: stats ? {
          readyState: stats.readyState,
          viewport: stats.viewport,
          dom: stats.dom,
          imageWidths: stats.imageWidths,
          resources: stats.resources,
          elapsedMs: stats.elapsedMs,
          lastStage: stats.lastStage
        } : undefined,
        previous: previous ? {
          visitId: previous.visitId,
          url: previous.url ? String(previous.url).slice(0, 300) : undefined,
          lastStage: previous.lastStage,
          startedAt: previous.startedAt,
          lastBeat: previous.lastBeat,
          interactionState: previous.interactionState,
          viewport: previous.viewport,
          theme: previous.theme
        } : undefined,
        src: extra.src ? String(extra.src).slice(0, 300) : undefined,
        resourceUrl: extra.resourceUrl ? String(extra.resourceUrl).slice(0, 300) : undefined,
        resourceTag: extra.resourceTag,
        resourceType: extra.resourceType,
        message: extra.message ? String(extra.message).slice(0, 500) : undefined,
        filename: extra.filename,
        lineno: extra.lineno,
        colno: extra.colno,
        error: extra.error ? String(extra.error).slice(0, 1000) : undefined,
        reason: extra.reason ? String(extra.reason).slice(0, 1000) : undefined
      }
    };
  }

  function readPersistedEvents() {
    try {
      var value = window.localStorage.getItem(eventQueueKey);
      return value ? JSON.parse(value) : [];
    } catch (error) {
      return [];
    }
  }

  function persistEvent(payload) {
    if (!payload || payload.message.indexOf('arthur_pdp_recovered') === 0) return;
    try {
      var events = readPersistedEvents();
      events.push(compactForStorage(payload));
      window.localStorage.setItem(eventQueueKey, JSON.stringify(events.slice(-80)));
    } catch (error) {}
  }

  function clearPersistedEvents() {
    try {
      window.localStorage.removeItem(eventQueueKey);
    } catch (error) {}
  }

  function cleanStoredVisit(reason) {
    var current = safeStorageRead();
    if (!current || current.visitId !== visitId) return;
    current.clean = true;
    current.cleanReason = reason;
    current.endedAt = Date.now();
    current.lastStage = lastStage;
    safeStorageWrite(current);
    clearPersistedEvents();
  }

  function getTheme() {
    return window.Shopify && window.Shopify.theme ? window.Shopify.theme : null;
  }

  function getConnection() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return null;
    return {
      effectiveType: connection.effectiveType || null,
      downlink: connection.downlink || null,
      rtt: connection.rtt || null,
      saveData: !!connection.saveData
    };
  }

  function imageWidthFromUrl(url) {
    if (!url) return null;
    var match = String(url).match(/[?&]width=(\d+)/);
    return match ? Number(match[1]) : null;
  }

  function collectStats() {
    var images = Array.prototype.slice.call(document.images || []);
    var productImages = images.filter(function (img) {
      return img.currentSrc && img.currentSrc.indexOf('/cdn/shop/files/') !== -1;
    });
    var resourceImages = [];

    try {
      resourceImages = performance.getEntriesByType('resource').filter(function (entry) {
        return entry.initiatorType === 'img' || /\.(jpg|jpeg|png|webp|gif)(\?|$)/i.test(entry.name);
      });
    } catch (error) {}

    return {
      url: window.location.href,
      path: window.location.pathname,
      title: document.title,
      readyState: document.readyState,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        dpr: window.devicePixelRatio || 1
      },
      theme: getTheme(),
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      deviceMemory: navigator.deviceMemory || null,
      connection: getConnection(),
      dom: {
        imgCount: images.length,
        productImgCount: productImages.length,
        eagerImgCount: images.filter(function (img) { return img.loading === 'eager'; }).length,
        highPriorityImgCount: images.filter(function (img) { return img.getAttribute('fetchpriority') === 'high'; }).length,
        completeImgCount: images.filter(function (img) { return img.complete; }).length,
        brokenImgCount: images.filter(function (img) { return img.complete && img.naturalWidth === 0; }).length,
        productMediaItems: document.querySelectorAll('[data-product-media-type-image]').length,
        thumbnailItems: document.querySelectorAll('.product-thumbnail-list-item').length,
        splideSlides: document.querySelectorAll('.splide__slide').length,
        splideClones: document.querySelectorAll('.splide__slide--clone').length
      },
      imageWidths: images.reduce(function (counts, img) {
        var width = imageWidthFromUrl(img.currentSrc || img.src);
        if (width) counts[width] = (counts[width] || 0) + 1;
        return counts;
      }, {}),
      resources: {
        imgResourceCount: resourceImages.length,
        imgTransferBytes: resourceImages.reduce(function (total, entry) {
          return total + (entry.transferSize || 0);
        }, 0),
        imgEncodedBytes: resourceImages.reduce(function (total, entry) {
          return total + (entry.encodedBodySize || 0);
        }, 0)
      },
      elapsedMs: Date.now() - startedAt,
      lastStage: lastStage
    };
  }

  function getProductSlideshow() {
    return document.querySelector('.splide--product');
  }

  function getSlideState(sourceElement) {
    var root = getProductSlideshow();
    var slide = sourceElement && sourceElement.closest ? sourceElement.closest('.splide__slide') : null;
    var slides = root ? Array.prototype.slice.call(root.querySelectorAll('.splide__slide:not(.splide__slide--clone)')) : [];
    var activeSlide = slide || (root && root.querySelector('.splide__slide.is-active:not(.splide__slide--clone)')) || null;
    var image = activeSlide ? activeSlide.querySelector('img') : null;
    var mediaWrapper = activeSlide ? activeSlide.querySelector('[data-product-single-media-wrapper]') : null;
    var mediaId = activeSlide ? activeSlide.getAttribute('data-media-id') : null;

    if (!mediaId && mediaWrapper) {
      mediaId = mediaWrapper.getAttribute('data-product-single-media-wrapper');
    }

    return {
      rootId: root ? root.id : null,
      mediaId: mediaId,
      slideIndex: activeSlide ? slides.indexOf(activeSlide) : null,
      className: activeSlide ? activeSlide.className : null,
      imageSrc: image ? image.currentSrc || image.src : null,
      imageWidth: image ? imageWidthFromUrl(image.currentSrc || image.src) : null,
      imageNaturalWidth: image ? image.naturalWidth : null,
      imageNaturalHeight: image ? image.naturalHeight : null,
      imageComplete: image ? image.complete : null,
      imageLoading: image ? image.loading : null,
      imageFetchPriority: image ? image.getAttribute('fetchpriority') : null,
      slideCount: slides.length
    };
  }

  function withSentry(callback) {
    if (window.Sentry && typeof window.Sentry.captureMessage === 'function') {
      callback(window.Sentry);
      return true;
    }
    return false;
  }

  function addBreadcrumb(message, data, level) {
    withSentry(function (Sentry) {
      if (typeof Sentry.addBreadcrumb === 'function') {
        Sentry.addBreadcrumb({
          category: 'arthur-pdp-carousel',
          message: message,
          level: level || 'info',
          data: data || {}
        });
      }
    });
  }

  function updateSentryContext(extra) {
    withSentry(function (Sentry) {
      if (typeof Sentry.setTag === 'function') {
        Sentry.setTag('arthur_diag', 'pdp-ios');
        Sentry.setTag('arthur_pdp_visit_id', visitId);
      }
      if (typeof Sentry.setContext === 'function') {
        Sentry.setContext('arthur_pdp_latest_interaction', Object.assign({
          visitId: visitId,
          stage: lastStage,
          interactionState: interactionState
        }, extra || {}));
      }
    });
  }

  function flushQueue() {
    if (!queue.length) return;
    if (!withSentry(function (Sentry) {
      while (queue.length) {
        var item = queue.shift();
        if (typeof Sentry.addBreadcrumb === 'function') {
          Sentry.addBreadcrumb({
            category: 'arthur-pdp-diagnostics',
            message: item.message,
            level: 'info',
            data: item.extra
          });
        }
        Sentry.captureMessage(item.message, {
          level: item.level || 'info',
          tags: item.tags,
          extra: item.extra
        });
      }
      if (typeof Sentry.flush === 'function') {
        Sentry.flush(750).catch(function () {});
      }
    })) {
      window.setTimeout(flushQueue, 500);
    }
  }

  function send(message, extra, level) {
    if (sentCount >= maxEvents && message !== 'arthur_pdp_suspected_previous_crash') return;
    sentCount += 1;
    var payload = {
      message: message,
      level: level || 'info',
      tags: {
        arthur_diag: 'pdp-ios',
        path: window.location.pathname,
        visit_id: visitId,
        theme_id: getTheme() && getTheme().id ? String(getTheme().id) : 'unknown'
      },
      extra: Object.assign({
        visitId: visitId,
        stage: lastStage,
        href: window.location.href
      }, extra || {})
    };

    persistEvent(payload);
    queue.push(payload);
    flushQueue();
    updateSentryContext({ lastMessage: message });

    if (window.console && typeof window.console.info === 'function') {
      window.console.info('[Arthur PDP diagnostics]', message, payload.extra);
    }

    if (typeof window.arthurTrack === 'function') {
      try {
        window.arthurTrack(message, {
          visit_id: visitId,
          stage: lastStage,
          theme_id: payload.tags.theme_id
        });
      } catch (error) {}
    }
  }

  function mark(stage, extra, sendEvent) {
    lastStage = stage;
    var current = safeStorageRead() || {};
    current.visitId = visitId;
    current.clean = false;
    current.url = window.location.href;
    current.path = window.location.pathname;
    current.startedAt = startedAt;
    current.lastBeat = Date.now();
    current.lastStage = stage;
    current.theme = getTheme();
    current.userAgent = navigator.userAgent;
    current.interactionState = interactionState;
    current.viewport = {
      width: window.innerWidth,
      height: window.innerHeight,
      dpr: window.devicePixelRatio || 1
    };
    safeStorageWrite(current);
    updateSentryContext();
    if (sendEvent) send('arthur_pdp_diag_' + stage, extra || {});
  }

  function shouldSendCarouselCheckpoint() {
    return interactionState.swipeCount <= 20 || interactionState.swipeCount % 3 === 0;
  }

  function sendCarouselCheckpoint(trigger, sourceElement, extra) {
    var slideState = getSlideState(sourceElement);
    interactionState.lastMediaId = slideState.mediaId;
    interactionState.lastSlideIndex = slideState.slideIndex;
    interactionState.lastImageSrc = slideState.imageSrc;
    interactionState.lastImageWidth = slideState.imageWidth;
    interactionState.lastInteractionAt = Date.now();
    mark('carousel_' + trigger + '_' + interactionState.swipeCount, null, false);

    var payload = Object.assign({
      trigger: trigger,
      interactionState: interactionState,
      slideState: slideState,
      stats: collectStats()
    }, extra || {});

    addBreadcrumb('carousel_' + trigger, payload);

    if (shouldSendCarouselCheckpoint()) {
      send('arthur_pdp_swipe_checkpoint', payload, 'info');
    }
  }

  function bindCarouselDiagnostics() {
    var touchStartX = null;
    var touchStartY = null;
    var touchStartAt = null;

    document.addEventListener('touchstart', function (event) {
      if (!event.target.closest || !event.target.closest('.splide--product')) return;
      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStartAt = Date.now();
      addBreadcrumb('carousel_touchstart', {
        slideState: getSlideState(event.target),
        stats: collectStats()
      });
    }, { passive: true, capture: true });

    document.addEventListener('touchend', function (event) {
      if (!event.target.closest || !event.target.closest('.splide--product')) return;
      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch || touchStartX === null || touchStartY === null) return;
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      var isSwipe = Math.abs(deltaX) > 24 && Math.abs(deltaX) > Math.abs(deltaY);

      if (isSwipe) {
        interactionState.swipeCount += 1;
        interactionState.lastDirection = deltaX < 0 ? 'next' : 'prev';
        interactionState.lastDeltaX = Math.round(deltaX);
        interactionState.lastDeltaY = Math.round(deltaY);
        interactionState.lastInteractionAt = Date.now();

        sendCarouselCheckpoint('touchend', event.target, {
          durationMs: touchStartAt ? Date.now() - touchStartAt : null
        });
      }

      touchStartX = null;
      touchStartY = null;
      touchStartAt = null;
    }, { passive: true, capture: true });

    document.addEventListener('mediaVisible', function (event) {
      interactionState.mediaVisibleCount += 1;
      interactionState.lastInteractionAt = Date.now();
      sendCarouselCheckpoint('media_visible', event.target);

      if (interactionState.swipeCount <= 20 || interactionState.swipeCount % 3 === 0) {
        window.setTimeout(function () {
          send('arthur_pdp_post_swipe_sample', {
            interactionState: interactionState,
            slideState: getSlideState(event.target),
            stats: collectStats()
          }, 'info');
        }, 700);
      }
    }, true);

    document.addEventListener('mediaHidden', function (event) {
      addBreadcrumb('carousel_media_hidden', {
        interactionState: interactionState,
        slideState: getSlideState(event.target)
      });
    }, true);
  }

  var previous = safeStorageRead();
  if (previous && previous.clean !== true && previous.visitId !== visitId) {
    var ageMs = Date.now() - (previous.lastBeat || previous.startedAt || Date.now());
    var recoveredEvents = readPersistedEvents();
    if (ageMs < 24 * 60 * 60 * 1000) {
      send('arthur_pdp_suspected_previous_crash', {
        previous: previous,
        ageMs: ageMs,
        recoveredEvents: recoveredEvents.slice(-50),
        currentStats: collectStats()
      }, 'warning');
      if (recoveredEvents.length) {
        send('arthur_pdp_recovered_events_after_unclean_exit', {
          recoveredEvents: recoveredEvents.slice(-50),
          recoveredEventCount: recoveredEvents.length
        }, 'warning');
      }
    }
  }

  mark('started', collectStats(), true);
  bindCarouselDiagnostics();

  window.setTimeout(function () {
    if (!window.Sentry || typeof window.Sentry.captureMessage !== 'function') {
      var payload = {
        message: 'arthur_pdp_sentry_unavailable',
        level: 'warning',
        tags: {
          arthur_diag: 'pdp-ios',
          path: window.location.pathname,
          visit_id: visitId,
          theme_id: getTheme() && getTheme().id ? String(getTheme().id) : 'unknown'
        },
        extra: {
          visitId: visitId,
          stage: lastStage,
          href: window.location.href,
          message: 'Sentry loader/API was unavailable after 2500ms. Safari privacy protection or a content blocker may have blocked telemetry.',
          stats: collectStats()
        }
      };
      persistEvent(payload);
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('[Arthur PDP diagnostics] Sentry unavailable after 2500ms');
      }
      return;
    }

    send('arthur_pdp_sentry_available', {
      stats: collectStats()
    }, 'info');
  }, 2500);

  heartbeatTimer = window.setInterval(function () {
    mark('heartbeat', null, false);
  }, 1000);

  document.addEventListener('DOMContentLoaded', function () {
    mark('dom_content_loaded', collectStats(), true);
  });

  window.addEventListener('load', function () {
    mark('window_load', collectStats(), true);
  });

  [2000, 5000, 10000].forEach(function (delay) {
    window.setTimeout(function () {
      mark('sample_' + delay, collectStats(), true);
    }, delay);
  });

  window.addEventListener('error', function (event) {
    if (event.target && event.target.tagName === 'IMG') {
      send('arthur_pdp_image_error', {
        src: event.target.currentSrc || event.target.src,
        outerHTML: event.target.outerHTML ? event.target.outerHTML.slice(0, 500) : null,
        stats: collectStats()
      }, 'warning');
      return;
    }

    if (event.target && (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
      send('arthur_pdp_resource_error', {
        resourceTag: event.target.tagName,
        resourceType: event.target.getAttribute('rel') || event.target.getAttribute('type') || null,
        resourceUrl: event.target.src || event.target.href || null,
        outerHTML: event.target.outerHTML ? event.target.outerHTML.slice(0, 500) : null,
        stats: collectStats()
      }, 'warning');
      return;
    }

    send('arthur_pdp_window_error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error && event.error.stack ? event.error.stack : String(event.error || '')
    }, 'error');
  }, true);

  window.addEventListener('unhandledrejection', function (event) {
    send('arthur_pdp_unhandled_rejection', {
      reason: event.reason && event.reason.stack ? event.reason.stack : String(event.reason || '')
    }, 'error');
  });

  document.addEventListener('visibilitychange', function () {
    mark('visibility_' + document.visibilityState, collectStats(), document.visibilityState === 'hidden');
  });

  window.addEventListener('pagehide', function () {
    window.clearInterval(heartbeatTimer);
    cleanStoredVisit('pagehide');
  });
})();
